// Generated with util/create-component.js
import Image from './Image';

export default Image;
